const StopIcon = () => {
    return (
        <svg width="29px" height="28px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="14.5829429%" y1="14.574848%" x2="85.3911513%" y2="85.3830563%" id="linearGradient1">
                    <stop stopColor="#96EAF1" offset="0%"></stop>
                    <stop stopColor="#98E3F0" offset="12.32%"></stop>
                    <stop stopColor="#9FD1EC" offset="29.66%"></stop>
                    <stop stopColor="#A9B3E5" offset="49.99%"></stop>
                    <stop stopColor="#B889DD" offset="72.58%"></stop>
                    <stop stopColor="#CA54D2" offset="96.77%"></stop>
                    <stop stopColor="#CD4CD0" offset="100%"></stop>
                    <stop stopColor="#CF50D1" offset="100%"></stop>
                    <stop stopColor="#D55DD3" offset="100%"></stop>
                    <stop stopColor="#DF73D6" offset="100%"></stop>
                    <stop stopColor="#EE91DB" offset="100%"></stop>
                    <stop stopColor="#FFB6E1" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="-0.134615385%" y1="49.9253394%" x2="99.9850679%" y2="49.9253394%" id="linearGradient2">
                    <stop stopColor="#96EAF1" offset="0%"></stop>
                    <stop stopColor="#98E3F0" offset="12.32%"></stop>
                    <stop stopColor="#9FD1EC" offset="29.66%"></stop>
                    <stop stopColor="#A9B3E5" offset="49.99%"></stop>
                    <stop stopColor="#B889DD" offset="72.58%"></stop>
                    <stop stopColor="#CA54D2" offset="96.77%"></stop>
                    <stop stopColor="#CD4CD0" offset="100%"></stop>
                    <stop stopColor="#CF50D1" offset="100%"></stop>
                    <stop stopColor="#D55DD3" offset="100%"></stop>
                    <stop stopColor="#DF73D6" offset="100%"></stop>
                    <stop stopColor="#EE91DB" offset="100%"></stop>
                    <stop stopColor="#FFB6E1" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="PPDesktopChatThreadChartsAndGraphs1920" transform="translate(-1743, -1520)">
                    <g id="Group4" transform="translate(1743.5, 1520)">
                        <circle id="Oval" stroke="url(#linearGradient1)" strokeWidth="2" cx="14" cy="14" r="13"></circle>
                        <path d="M17.6108597,20 L10.3891403,20 C9.05882353,20 8,18.9140271 8,17.6108597 L8,10.3891403 C8,9.05882353 9.08597285,8 10.3891403,8 L17.6108597,8 C18.9411765,8 20,9.08597285 20,10.3891403 L20,17.6108597 C20,18.9140271 18.9140271,20 17.6108597,20 Z" id="PathCopy" fill="url(#linearGradient2)" fillRule="nonzero" transform="translate(14, 14) rotate(-270) translate(-14, -14)"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default StopIcon;
